<template>
  <div class="rich-text-menus">
    <EditorMenuBubble :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.bold()"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <v-icon small>mdi-format-bold</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.italic()"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <v-icon small>mdi-format-italic</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.underline()"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <v-icon small>mdi-format-underline</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.paragraph()"
          :class="{ 'is-active': isActive.paragraph() }"
          @click="commands.paragraph"
        >
          <v-icon small>mdi-format-pilcrow</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.heading({ level: 1 })"
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >
          <v-icon small>mdi-format-header-1</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.heading({ level: 2 })"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          <v-icon small>mdi-format-header-2</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.heading({ level: 3 })"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          <v-icon small>mdi-format-header-3</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.bullet_list()"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <v-icon small>mdi-format-list-bulleted</v-icon>
        </v-btn>

        <v-btn
          icon
          small
          tile
          class="menubar__button"
          :active="isActive.ordered_list()"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <v-icon small>mdi-format-list-numbered</v-icon>
        </v-btn>

        <v-btn icon tile small class="menubar__button" @click="commands.undo">
          <v-icon small>mdi-undo</v-icon>
        </v-btn>

        <v-btn icon tile small class="menubar__button" @click="commands.redo">
          <v-icon small>mdi-redo</v-icon>
        </v-btn>
      </div>
    </EditorMenuBubble>
    <EditorMenuBubble
      class="menububble"
      :editor="editor"
      @hide="hideLinkMenu"
      v-slot="{ commands, isActive, getMarkAttrs, menu }"
    >
      <div
        class="menububble"
        :class="{ 'is-active': menu.isActive }"
        :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
      >
        <form
          class="menububble__form"
          v-if="linkMenuIsActive"
          @submit.prevent="setLinkUrl(commands.link, linkUrl)"
        >
          <input
            class="menububble__input"
            type="text"
            v-model="linkUrl"
            placeholder="https://"
            ref="linkInput"
            @keydown.esc="hideLinkMenu"
          />
          <v-btn
            class="menububble__button"
            @click="setLinkUrl(commands.link, null)"
            type="button"
            small
            dark
            color="black"
          >
            <v-icon small right color="white">
              mdi-close-circle-outline
            </v-icon>
          </v-btn>
        </form>

        <template v-else>
          <v-btn
            class="menububble__button"
            @click="showLinkMenu(getMarkAttrs('link'))"
            :class="{ 'is-active': isActive.link() }"
            dark
            small
            color="black"
          >
            <span>{{ isActive.link() ? 'Update Link' : 'Add Link' }}</span>
            <v-icon small right>
              mdi-link-variant
            </v-icon>
          </v-btn>
        </template>
        <!-- <v-btn
          icon
          tile
          small
          class="menubar__button"
          :active="isActive.bold()"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <v-icon small :color="isActive.bold() ? 'blue' : 'white'"
            >mdi-format-bold</v-icon
          >
        </v-btn>

        <v-btn
          icon
          tile
          small
          class="menubar__button"
          :active="isActive.italic()"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <v-icon small :color="isActive.italic() ? 'blue' : 'white'"
            >mdi-format-italic</v-icon
          >
        </v-btn>

        <v-btn
          icon
          tile
          small
          class="menubar__button"
          :active="isActive.underline()"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <v-icon small :color="isActive.underline() ? 'blue' : 'white'"
            >mdi-format-underline</v-icon
          >
        </v-btn> -->
      </div>
    </EditorMenuBubble>
  </div>
</template>

<script>
import { EditorMenuBubble } from 'tiptap'
export default {
  name: 'RichTextMenus',
  props: {
    editor: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: { EditorMenuBubble },
  data() {
    return {
      linkUrl: null,
      linkMenuIsActive: false,
    }
  },
  methods: {
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkMenu() {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    setLinkUrl(command, url) {
      command({ href: url })
      this.hideLinkMenu()
    },
  },
}
</script>

<style lang="scss" scoped></style>
